import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Navigation, Clock } from 'lucide-react';

const MapSection = () => {
  return (
    <section id="map" className="relative bg-[#121816] py-32 md:py-44 overflow-hidden" data-testid="map-section">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">

        <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20">
          <div className="col-span-12 lg:col-span-3">
            <div className="overline">Chapter VI</div>
            <div className="numeral text-7xl md:text-8xl text-[#D4AF37]/30 mt-4">06</div>
          </div>
          <div className="col-span-12 lg:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif text-4xl md:text-6xl lg:text-7xl font-light text-[#E8E3D9] leading-[1.05]"
            >
              How you find <span className="italic text-[#D4AF37]">us.</span>
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          {/* map */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:col-span-8 border border-[#D4AF37]/30 overflow-hidden h-[440px] md:h-[520px] relative"
          >
            <iframe
              src="https://www.google.com/maps?q=Tuskermark+Safari+Retreat+Tholpetty+Kerala&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'invert(0.92) hue-rotate(180deg) saturate(0.7) brightness(0.95)' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Tuskermark Safari Retreat Location"
            />
            {/* corner marks */}
            <div className="absolute top-4 left-4 w-6 h-6 border-t border-l border-[#D4AF37]" />
            <div className="absolute top-4 right-4 w-6 h-6 border-t border-r border-[#D4AF37]" />
            <div className="absolute bottom-4 left-4 w-6 h-6 border-b border-l border-[#D4AF37]" />
            <div className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-[#D4AF37]" />
          </motion.div>

          {/* details */}
          <div className="lg:col-span-4 space-y-px bg-[#D4AF37]/15">
            <div className="bg-[#121816] p-6 md:p-7">
              <div className="flex items-start gap-3 mb-2">
                <MapPin size={16} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <div className="overline">Address</div>
              </div>
              <p className="text-[13px] text-[#C4BFB1] leading-[1.85] pl-7">
                Tuskermark Safari Resort<br/>
                Tholpetty Wildlife Sanctuary<br/>
                Kutta–Mananthavady Road<br/>
                Tholpetty, Kerala — 670646
              </p>
            </div>
            <div className="bg-[#121816] p-6 md:p-7">
              <div className="flex items-start gap-3 mb-2">
                <Phone size={16} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <div className="overline">Reach us</div>
              </div>
              <div className="pl-7 space-y-1">
                <a href="tel:+918310838799" className="block text-[#E8E3D9] hover:text-[#D4AF37] transition-colors text-[14px]">+91 83108 38799</a>
                <a href="tel:+918618285170" className="block text-[#E8E3D9] hover:text-[#D4AF37] transition-colors text-[14px]">+91 86182 85170</a>
                <a href="mailto:info@tuskermark.com" className="block text-[#8E9A95] hover:text-[#D4AF37] transition-colors text-[12px] break-all">info@tuskermark.com</a>
              </div>
            </div>
            <div className="bg-[#121816] p-6 md:p-7">
              <div className="flex items-start gap-3 mb-2">
                <Clock size={16} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <div className="overline">Hours</div>
              </div>
              <p className="text-[13px] text-[#C4BFB1] leading-[1.8] pl-7">
                Check-in 1:00 PM<br/>
                Check-out 11:00 AM
              </p>
            </div>
            <a
              href="https://www.google.com/maps/search/Tuskermark+Safari+Retreat+Tholpetty+Kerala"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#D4AF37] hover:bg-[#E5C766] text-[#0B0F0E] p-6 md:p-7 flex items-center justify-between transition-colors"
              data-testid="get-directions-btn"
            >
              <span className="text-[12px] tracking-[0.25em] uppercase font-semibold">Get directions</span>
              <Navigation size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
